module.exports = __webpack_public_path__ + "static/videos-from-youtube-facebook-f66dc9a149dac64596ebb2283d11b389.svg";